"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Step1 = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var BasicInformation_1 = require("./BasicInformation");
var EnterpriseFeatures_1 = require("./EnterpriseFeatures");
var react_redux_1 = require("react-redux");
var Row = sok_ui_1.Grid.Row, Column = sok_ui_1.Grid.Column;
var status_1 = require("@caddigital/sok-reducers/lib/status");
var Step1 = function (props) {
    var fetchStatus = (0, react_redux_1.useSelector)(function (state) { return state.project.change; }).fetchStatus;
    return (React.createElement("div", { className: 'step1' },
        React.createElement(sok_ui_1.RequestStatusBox, { status: fetchStatus.value, statusList: Object.values(status_1.RequestStatusValue) },
            (0, translation_1.getLocalization)("change/company/fetching"),
            (0, translation_1.getLocalization)("change/company/fetched"),
            (0, translation_1.getLocalization)("change/company/failed")),
        React.createElement("div", { className: 'save-button' },
            React.createElement(sok_ui_1.Button, { color: 'base-green', disabled: props.isSaving === 'SAVING', text: (0, translation_1.getLocalization)('admin/projectsTab/toolTips/editProject/basicInformation/buttons/saveStep'), onClick: function () { return props.createProject(props.wizard); } })),
        React.createElement(Row, null,
            React.createElement(Column, { large: 6 },
                React.createElement(BasicInformation_1.default, __assign({}, props))),
            React.createElement(Column, { large: 6 },
                React.createElement(EnterpriseFeatures_1.default, __assign({}, props, { wizard: props.wizard, errors: props.step1.status === 'ERROR' ? props.step1.errors : undefined })))),
        React.createElement(sok_ui_1.RequestStatusBox, { status: props.wizard.isSaving, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
            React.createElement("span", null, (0, translation_1.getLocalization)('admin/projectManagement/saving')),
            React.createElement("span", null, (0, translation_1.getLocalization)('admin/projectManagement/saved')),
            React.createElement("span", null, (0, translation_1.getLocalization)('admin/projectManagement/failed')))));
};
exports.Step1 = Step1;
